"use client";

import { useForm } from "react-hook-form";

import { cn, useBreakpoints } from "~/services/shadcn";
import { Container } from "../../common/Container";
import { Form } from "../../ui";
import { NavbarDesktop } from "./desktop";
import { NavbarMobile } from "./mobile";

export type FormValues = {
  search: string;
  meta: {
    isPopoverOpen: boolean;
  };
};

export function Navbar({ className, ...props }: React.HTMLAttributes<HTMLElement>) {
  const form = useForm<FormValues>({
    defaultValues: {
      search: "",
      meta: {
        isPopoverOpen: false,
      },
    },
  });

  const { isWideEnough } = useBreakpoints();

  return (
    <div className="fixed left-0 right-0 top-0 z-50 flex h-[76px] max-w-[100vw] items-center bg-[#060606]">
      <Container>
        <nav className={cn("flex items-center px-2 font-semibold", className)} {...props}>
          <Form {...form}>{isWideEnough ? <NavbarDesktop /> : <NavbarMobile />}</Form>
        </nav>
      </Container>
    </div>
  );
}
